import _ from 'lodash'
import Dashboard_1 from '../assets/icons/dashboard/layout_icon_1'
import Dashboard_H2 from '../assets/icons/dashboard/layout_icon_h2'
import Dashboard_H2_1H2_2V2 from '../assets/icons/dashboard/layout_icon_h2_1h2_2v2'
import Dashboard_H2_1V2 from '../assets/icons/dashboard/layout_icon_h2_1v2'
import Dashboard_H2_1V2_2V2 from '../assets/icons/dashboard/layout_icon_h2_1v2_2v2'
import Dashboard_H2_1V3 from '../assets/icons/dashboard/layout_icon_h2_1v3'
import Dashboard_H2_2V2 from '../assets/icons/dashboard/layout_icon_h2_2v2'
import Dashboard_H2_2V3 from '../assets/icons/dashboard/layout_icon_h2_2v3'
import Dashboard_H3 from '../assets/icons/dashboard/layout_icon_h3'
import Dashboard_H4 from '../assets/icons/dashboard/layout_icon_h4'
import Dashboard_V2 from '../assets/icons/dashboard/layout_icon_v2'
import Dashboard_V2_1H2 from '../assets/icons/dashboard/layout_icon_v2_1h2'
import Dashboard_V2_1H2_2V2 from '../assets/icons/dashboard/layout_icon_v2_1h2_2v2'
import Dashboard_V2_2H2 from '../assets/icons/dashboard/layout_icon_v2_2h2'
import Dashboard_V2_2H3 from '../assets/icons/dashboard/layout_icon_v2_2h3'
import Dashboard_V3 from '../assets/icons/dashboard/layout_icon_v3'
import Dashboard_V4 from '../assets/icons/dashboard/layout_icon_v4'
import { ChartConfig } from '../components/chartV2/chart.typings'
import { ChartDrawingItem, DrawingDisplayType } from '../components/chartV2/drawingTools/drawing.interface'
import { PredefinedDashboard, WidgetTypes } from '../components/widgetDashboard/widgetDashboard.enums'
import { WidgetConfig, WidgetDashboardConfig } from '../components/widgetDashboard/widgetDashboard.interface'
import { getDefaultChartConfig } from './chart'
import { saveUserDashboard } from '../services/apis/dashboard'
import {DashboardNamespace, DashboardShareStatus, UserDashboardProto} from "../proto/generated/user-preference";
import { sortKeys } from './general'
import { getDefaultLayout } from '../components/widgetDashboard/widgetDashboard.helper'

const stripIndicatorErrorsFromChartConfig = (config: ChartConfig): ChartConfig => {
    if (!config?.seriesGroups) return config
    const seriesGroups: ChartConfig['seriesGroups'] = {}
    Object.entries(config.seriesGroups).forEach(([sgId, sg]) => {
        const { error, ...rest } = sg as Record<string, unknown>
        seriesGroups[sgId] = rest as typeof sg
    })
    return { ...config, seriesGroups }
}

export const isLayoutChanged = (layoutId: string, layout: WidgetDashboardConfig, dashboard: UserDashboardProto, chartConfigs: Record<string, ChartConfig>, drawings: Record<string, ChartDrawingItem[]>) => {
    if (!layoutId || !layout || !layout.widgets) return false
    const chartIds: number[] = Object.keys(layout.widgets).map(widgetKey => layout.widgets[parseInt(widgetKey)].slotId)
    const chartDrawings: Record<string, ChartDrawingItem[]> = {}
    const newChartConfigs: Record<string, ChartConfig> = {};
    chartIds.forEach((id) => {
        const chartId = `${layoutId}-${id}`
        const widgetType = layout.widgets[id]?.widgetType
        // Only include chart configs for CHART widgets - OI/OPTION/MULTI_STRIKE/FUTURE use different chart impls
        // and may have stale config from previous widget type, causing false "layout changed" detection
        if (widgetType === WidgetTypes.CHART && chartConfigs[chartId]) {
            const config = stripIndicatorErrorsFromChartConfig({ ...chartConfigs[chartId] } as ChartConfig)
            delete config.loading
            newChartConfigs[chartId] = config
        }
        if (widgetType === WidgetTypes.CHART) {
            chartDrawings[chartId] = drawings[chartId] || []
        }
    });

    const layoutToBeSaved = {
        panes: layout.panes,
        widgets: layout.widgets,
        syncSettings: layout.syncSettings,
        charts: newChartConfigs,
        drawings: chartDrawings
    }
    const sortedStr1 = JSON.stringify(sortKeys(layoutToBeSaved));
    const parsedLayout = JSON.parse(dashboard.layout);
    const layoutChartConfigs: Record<string, ChartConfig> = parsedLayout.charts || {};
    const newLayoutChartConfigs: Record<string, ChartConfig> = {};
    chartIds.forEach((id) => {
        const chartId = `${layoutId}-${id}`
        const widgetType = layout.widgets[id]?.widgetType
        if (widgetType === WidgetTypes.CHART && layoutChartConfigs[chartId]) {
            const config = stripIndicatorErrorsFromChartConfig({ ...layoutChartConfigs[chartId] } as ChartConfig)
            delete config.loading
            newLayoutChartConfigs[chartId] = config
        }
    });

    const sortedStr2 = JSON.stringify(sortKeys({...parsedLayout, charts: newLayoutChartConfigs}));
    return sortedStr1 !== sortedStr2;
}

export function getDashBoardIcon(id: PredefinedDashboard) {
    switch (id) {
        case PredefinedDashboard.LAYOUT_1:
            return Dashboard_1()
        case PredefinedDashboard.LAYOUT_H2:
            return Dashboard_H2()
        case PredefinedDashboard.LAYOUT_V2:
            return Dashboard_V2()
        case PredefinedDashboard.LAYOUT_H3:
            return Dashboard_H3()
        case PredefinedDashboard.LAYOUT_V3:
            return Dashboard_V3()
        case PredefinedDashboard.LAYOUT_H2_1V2:
            return Dashboard_H2_1V2()
        case PredefinedDashboard.LAYOUT_H2_2V2:
            return Dashboard_H2_2V2()
        case PredefinedDashboard.LAYOUT_V2_1H2:
            return Dashboard_V2_1H2()
        case PredefinedDashboard.LAYOUT_V2_2H2:
            return Dashboard_V2_2H2()
        case PredefinedDashboard.LAYOUT_H2_1H2_2V2:
            return Dashboard_H2_1H2_2V2()
        case PredefinedDashboard.LAYOUT_H2_1V2_2V2:
            return Dashboard_H2_1V2_2V2()
        case PredefinedDashboard.LAYOUT_H2_1V3:
            return Dashboard_H2_1V3()
        case PredefinedDashboard.LAYOUT_H2_2V3:
            return Dashboard_H2_2V3()
        case PredefinedDashboard.LAYOUT_H4:
            return Dashboard_H4()
        case PredefinedDashboard.LAYOUT_V2_1H2_2V2:
            return Dashboard_V2_1H2_2V2()
        case PredefinedDashboard.LAYOUT_V2_2H3:
            return Dashboard_V2_2H3()
        case PredefinedDashboard.LAYOUT_V4:
            return Dashboard_V4()
        default:
            return Dashboard_1()
    }
}

export function getPanesCount(id: PredefinedDashboard) {
    switch (id) {
        case PredefinedDashboard.LAYOUT_1:
            return 1
        case PredefinedDashboard.LAYOUT_H2:
        case PredefinedDashboard.LAYOUT_V2:
            return 2
        case PredefinedDashboard.LAYOUT_H3:
        case PredefinedDashboard.LAYOUT_V3:
        case PredefinedDashboard.LAYOUT_H2_1V2:
        case PredefinedDashboard.LAYOUT_H2_2V2:
        case PredefinedDashboard.LAYOUT_V2_1H2:
        case PredefinedDashboard.LAYOUT_V2_2H2:
            return 3
        case PredefinedDashboard.LAYOUT_H2_1H2_2V2:
        case PredefinedDashboard.LAYOUT_H2_1V2_2V2:
        case PredefinedDashboard.LAYOUT_H2_1V3:
        case PredefinedDashboard.LAYOUT_H2_2V3:
        case PredefinedDashboard.LAYOUT_H4:
        case PredefinedDashboard.LAYOUT_V2_1H2_2V2:
        case PredefinedDashboard.LAYOUT_V2_2H3:
        case PredefinedDashboard.LAYOUT_V4:
            return 4
        default:
            return 1
    }
}

export const getSavedLayout = (id: string, activeLayout: WidgetDashboardConfig, chartConfigs: Record<string, ChartConfig>, drawings: Record<string, ChartDrawingItem[]>, key = '') => {
    let updatedLayout = {
        ...activeLayout
    }
    const chartIds: number[] = Object.values(updatedLayout.widgets || {}).map((widget) => widget.slotId) as number [];
    const chartDrawings: Record<string, ChartDrawingItem[]> = {}
    const layoutChartConfigs: Record<string, ChartConfig> = {}
    chartIds.forEach((chart_id) => {
        const chartId = `${id}-${chart_id}`
        let config = chartConfigs[chartId]
        const widget = updatedLayout.widgets[chart_id]
        // Ensure F&O widgets have minimal config when switching layouts - prevents 4th pane etc. from loading empty after refresh
        if (!config?.futureChartSettings?.securityKey && widget?.widgetType === WidgetTypes.FUTURE_CHART && widget?.settings?.key) {
            config = { ...config, futureChartSettings: { key: widget.settings.key, ...config?.futureChartSettings } }
        }
        if (!config?.atmOptionChartSettings?.securityKey && [WidgetTypes.ATM_OPTION_CHART, WidgetTypes.OPTION_CHART].includes(widget?.widgetType) && widget?.settings?.key) {
            config = { ...config, atmOptionChartSettings: { key: widget.settings.key, ...config?.atmOptionChartSettings } }
        }
        if (!config?.multiStrikeChartSettings?.key && widget?.widgetType === WidgetTypes.MULTI_STRIKE_CHART && widget?.settings?.key) {
            config = { ...config, multiStrikeChartSettings: { key: widget.settings.key, ...config?.multiStrikeChartSettings } }
        }
        layoutChartConfigs[chartId] = config
        if(updatedLayout.widgets[chart_id].widgetType === WidgetTypes.CHART) chartDrawings[chartId] = drawings[chartId] || []
    })

    const layoutToBeSaved = {
        panes: updatedLayout.panes,
        widgets: updatedLayout.widgets,
        syncSettings: updatedLayout.syncSettings,
        charts: Object.keys(layoutChartConfigs).length === 0 ? { [`${id}-1`]: getDefaultChartConfig() } : layoutChartConfigs,
        drawings: chartDrawings
    }

    return layoutToBeSaved

}

export const processAndUpdateUserDashboards = async (userDashboards: UserDashboardProto[]) => {
    let dashboards = [...userDashboards].sort((a, b) => (b.isDefault ? 1 : 0) - (a.isDefault ? 1 : 0));
    let charts: Record<string, ChartConfig> = {}, drawings: Record<string, ChartDrawingItem[]> = {},
            layouts: Record<string, WidgetDashboardConfig> = {}
    if (dashboards && dashboards.length > 0) {
        dashboards = await Promise.all(
            dashboards.map(async (dashboard) => {
                if (dashboard.isPredefined) return dashboard;

                let update = false;
                let layout = JSON.parse(dashboard.layout);
                if (!layout) {
                    layout = getDefaultLayout()
                }
                if (!layout.charts) {
                    layout.charts = {};
                    update = true;
                }
                const layoutWidgets = layout.widgets as Record<number, WidgetConfig<any>>;;
                for (const widgetKey in layoutWidgets) {
                    const widget = layoutWidgets[widgetKey];

                    if (!widget) continue;
                    const chartId = widget.settings?.chartId;
                    const key = widget.settings?.key
                    const securities = layout.charts[chartId]?.multiStrikeChartSettings?.securities;
                    if (chartId && securities && Object.values(securities)[0] && (
                        "callSecKey" in (Object.values(securities)[0] as Record<string, any>) ||
                        "putSecKey" in (Object.values(securities)[0] as Record<string, any>) ||
                        "callPut" in (Object.values(securities)[0] as Record<string, any>)
                    )) {
                        update = true;
                        layout.charts[chartId].multiStrikeChartSettings.securities = Object.fromEntries(
                            Object.entries(securities).map(([strike, data]) => [strike, (data as { callPut: any }).callPut])
                        );
                        layout.charts[chartId].multiStrikeChartSettings = { ...layout.charts[chartId].multiStrikeChartSettings, key: key }
                    }

                    if ([WidgetTypes.OPTION_CHART, WidgetTypes.ATM_OPTION_CHART, WidgetTypes.FUTURE_CHART].includes(widget.widgetType)) {
                        widget.widgetType = WidgetTypes.CHART;
                        update = true;
                    }
                }

                for (const chartId in layout.drawings) {
                    const drawings = layout.drawings[chartId];
                    const newDrawings: ChartDrawingItem[] = [];
                    drawings.forEach((drawing: ChartDrawingItem) => {
                        if (["oiHistorical", "oiHeatmap", "oiProfile", "contractSwitch", "corporateAction", "companyEvent", "replaySelection"].includes(drawing.type)) {
                            return;
                        }
                        newDrawings.push({
                            ...drawing,
                            displayType: DrawingDisplayType.DRAWING
                        });
                    })
                    if (newDrawings.length !== drawings.length) {
                        update = true;
                        layout.drawings[chartId] = newDrawings;
                    }
                }

                if (update) {
                    const updatedDashboard = { ...dashboard, layout: JSON.stringify(layout) };
                    await saveUserDashboard({
                        dashboard: {
                            id: updatedDashboard.id,
                            layout: updatedDashboard.layout,
                            name: updatedDashboard.name,
                            isDefault: updatedDashboard?.isDefault || false,
                            isPredefined: false,
                            shareState: DashboardShareStatus.NOT_SHARED,
                            platform: updatedDashboard.platform,
                            namespace: DashboardNamespace.CHART
                        },
                    });
                }
                const updatedDashboard = { ...dashboard, layout: JSON.stringify(layout) };
                return updatedDashboard;
            })
        );

        
        dashboards?.forEach((dashboard: UserDashboardProto) => {
            if (!dashboard) return;
            const { id, layout: dashboardLayout, isPredefined } = dashboard;
            if (isPredefined) return;
            const parsedLayout = JSON.parse(dashboardLayout)
            const strippedCharts: Record<string, ChartConfig> = {}
            Object.entries(parsedLayout.charts || {}).forEach(([chartId, config]) => {
                strippedCharts[chartId] = stripIndicatorErrorsFromChartConfig(config as ChartConfig)
            })
            charts = {
                ...charts,
                ...strippedCharts
            }
            drawings = {
                ...drawings,
                ...parsedLayout.drawings
            }
            layouts = {
                ...layouts,
                [id]: {
                    panes: parsedLayout.panes,
                    singleMode: parsedLayout?.panes?.panes?.length === 1 || parsedLayout?.panes?.panes?.length === 0,
                    syncSettings: parsedLayout.syncSettings,
                    widgets: parsedLayout.widgets
                }
            }
        })
    }

    return {
        dashboards,
        charts,
        drawings,
        layouts
    }
}